import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  GET_FOOD_SHIFT_REPORT_LIST,
  SEARCH_FOOD_SHIFT_REPORT,
} from "./actionType";

import {
  getFoodShiftReportListSuccess,
  getFoodShiftReportListFailure,
  searchFoodShiftReportSuccess,
  searchFoodShiftReportFailure,
} from "./action";

import {
  apiGetFoodShiftReportList,
  apiSearchFoodShiftReport,
} from "../../helpers/fakebackend_helper";

//GET_FOOD_SHIFT_REPORT_LIST
function* getFoodShiftReportList() {
  try {
    const response = yield call(apiGetFoodShiftReportList);
    yield put(getFoodShiftReportListSuccess(response));
  } catch (error) {
    yield put(getFoodShiftReportListFailure(error));
  }
}

export function* watchGetFoodShiftReportList() {
  yield takeEvery(GET_FOOD_SHIFT_REPORT_LIST, getFoodShiftReportList);
}

//SEARCH_FOOD_SHIFT_REPORT
function* searchFoodShiftReport({ payload }) {
  try {
    const response = yield call(apiSearchFoodShiftReport, payload);
    yield put(searchFoodShiftReportSuccess(response));
  } catch (error) {
    yield put(searchFoodShiftReportFailure(error));
  }
}

export function* watchSearchFoodShiftReport() {
  yield takeEvery(SEARCH_FOOD_SHIFT_REPORT, searchFoodShiftReport);
}

export default function* ShiftReport() {
  yield all([
    fork(watchGetFoodShiftReportList),
    fork(watchSearchFoodShiftReport),
  ]);
}
